/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames = require("classnames");
var PropTypes = require("prop-types");
var moduleClassNameFactory_1 = require("../util/moduleClassNameFactory");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./BarcodeCardPending.css'); }
var IconLink_1 = require("../IconLink");
var Zzz_1 = require("../Zzz");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-barcodeCardPending");
exports.BarcodeCardPending = function BarcodeCardPending(_a) {
    var title = _a.title, footer = _a.footer, _b = _a.link, linkTitle = _b.title, _c = _b.props, linkClassName = _c.className, linkPropsWithoutClassName = tslib_1.__rest(_c, ["className"]), description = _a.description, className = _a.className;
    return (React.createElement("div", { className: classnames(moduleClassName(), className) },
        React.createElement("div", { className: moduleClassName("content") },
            React.createElement(Zzz_1.Zzz, { size: "large", className: moduleClassName("zzz") }),
            React.createElement("div", { className: moduleClassName("title") }, title),
            React.createElement("div", { className: moduleClassName("description") }, description),
            React.createElement(IconLink_1.IconLink, tslib_1.__assign({ type: "external-link", reverse: true, className: classnames(moduleClassName("link"), linkClassName) }, linkPropsWithoutClassName), linkTitle)),
        React.createElement("div", { className: moduleClassName("footer") }, footer)));
};
exports.BarcodeCardPending.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    footer: PropTypes.string.isRequired,
    link: PropTypes.shape({
        title: PropTypes.string.isRequired,
        props: PropTypes.object.isRequired /* any prop for the link element */
    }).isRequired,
    className: PropTypes.string
};